import { render } from "./cityFrom.svg?vue&type=template&id=59f76871"
const script = {}

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__